import type { JSX } from 'react';
import OutcomeDetails from '../common/OutcomeDetails';
import DataActionConfiguration from '../common/dataActions/DataActionConfiguration';
import screens from '../common/screens';
import { useMapElement } from '../contextProviders/MapElementProvider';
import DeleteConfiguration from './DeleteConfiguration';

const Delete = () => {
    const {
        currentScreen,
        mapElement,
        selectedOutcomeIndex,
        onReturnToDefaultScreen,
        setSelectedOutcomeIndex,
    } = useMapElement();

    let screen: JSX.Element | null = null;

    switch (currentScreen) {
        case screens.delete:
            screen = <DeleteConfiguration />;
            break;
        case screens.dataAction:
            screen = <DataActionConfiguration />;
            break;
        case screens.outcome: {
            const selectedOutcome =
                typeof selectedOutcomeIndex === 'number' &&
                mapElement?.outcomes?.[selectedOutcomeIndex]
                    ? mapElement?.outcomes?.[selectedOutcomeIndex]
                    : null;

            screen = (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={onReturnToDefaultScreen}
                    onCancel={() => {
                        onReturnToDefaultScreen();
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
            break;
        }
        default:
            break;
    }

    return screen;
};

export default Delete;
